export default __webpack_public_path__ + "static/media/130.1c0a0dcd.png";